<template>
    <div>
        <ts-page-title
            :title="$t('company.pageTitle')"
            :breadcrumb="[
                { text: $t('home'), href: '/' },
                {
                    text: $t('company.pageTitle'),
                    active: true
                }
            ]"
        />
        <ts-panel>
            <ts-panel-wrapper
                class="tw-flex tw-items-center tw-justify-between"
            >
                <ts-button color="warning" @click="$router.push({ name: 'company-create' })">{{
                    $t('addNew')
                }}</ts-button>
                <div class="tw-justify-end tw-space-x-2">
                    <Input
                        search
                        v-model="search"
                        :placeholder="$t('company.search')"
                        :style="width"
                        @on-focus="() => (width = 'width: 500px')"
                        @on-blur="() => (width = 'width: 300px')"
                    />
                </div>
            </ts-panel-wrapper>
            <Table
                :columns="columns"
                :data="resources"
                size="small"
                :loading="loading"
                max-height="700"
                stripe
            >
                <template slot-scope="{ row }" slot="action">
                    <a
                        href="#"
                        class="text-primary ml-2"
                        @click.prevent="onEdit(row)"
                        v-tooltip="$t('edit')"
                    >
                        <Icon type="ios-create" size="20" />
                    </a>
                    <Poptip
                        confirm
                        :title="$t('areYouSure')"
                        @on-ok="onDelete(row)"
                        :transfer="true"
                        :ok-text="$t('yes')"
                        :cancel-text="$t('no')"
                    >
                        <a
                            class="ml-2 text-danger"
                            v-tooltip="$t('delete')"
                            :disabled="row._deleting"
                        >
                            <i
                                class="fas fa-circle-notch fa-spin"
                                v-if="row._deleting"
                            ></i>
                            <Icon type="ios-trash" size="20" v-else />
                        </a>
                    </Poptip>
                </template>
            </Table>
            <div class="tw-flex tw-items-center tw-justify-end tw-p-4">
                <ts-i-pagination
                    v-model="pagination"
                    @navigate="fetchData"
                ></ts-i-pagination>
            </div>
        </ts-panel>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { debounce } from "lodash";
export default {
    name: "companyIndex",
    data() {
        return {
            loading: false,
            width: "width: 300px"
        };
    },
    computed: {
        ...mapState("corporate/company", ["resources", "pagination"]),
        search: {
            get() {
                return this.$store.state.corporate.company.search;
            },
            set(newValue) {
                this.$store.commit("corporate/company/SET_SEARCH", newValue);
                this.$store.commit("corporate/company/RESET_CURRENT_PAGE");
            }
        },
        columns() {
            return [
                {
                    title: this.$t("company.prefixCode"),
                    key: "prefix_code",
                    minWidth: 130,
                    fixed: "left",
                    sortable: true
                },
                {
                    title: this.$t("company.nameEn"),
                    key: "company_name_en",
                    minWidth: 250,
                    sortable: true
                },
                {
                    title: this.$t("company.nameKh"),
                    key: "company_name_kh",
                    minWidth: 250,
                    sortable: true
                },
                {
                    title: this.$t("company.phoneNumber"),
                    key: "company_phone",
                    minWidth: 150,
                    align: "center",
                    sortable: true
                },
                {
                    title: this.$t("company.email"),
                    key: "company_email",
                    align: "center",
                    minWidth: 250
                },
                {
                    title: this.$t("company.website"),
                    key: "company_website",
                    align: "center",
                    minWidth: 200
                },
                {
                    title: this.$t("company.address"),
                    key: "company_address",
                    minWidth: 250
                },
                {
                    title: this.$t("actions"),
                    key: "action",
                    slot: "action",
                    fixed: "right",
                    align: "center",
                    width: 90
                }
            ];
        }
    },
    methods: {
        fetchData(attributes) {
            this.loading = true;
            this.$store
                .dispatch("corporate/company/fetch", attributes)
                .catch(error => {
                    this.loading = false;
                    this.notice({ type: "error", text: error.message });
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        onEdit(record) {
            this.$store.commit("corporate/company/SET_EDIT_DATA", record);
            this.$router.push({
                name: "company-edit",
                params: { id: record.company_id }
            });
        },
        async onDelete(record) {
            record._deleting = true;
            this.$store
                .dispatch("corporate/company/destroy", record.company_id)
                .then(response => {
                    this.fetchData();
                    record._deleting = false;
                    this.notice({
                        type: response.message_id == 0 ? "success" : "warning",
                        text: response.message
                    });
                })
                .catch(error => {
                    this.notice({ type: "error", text: error.message });
                    record._deleting = false;
                });
        },
        notice(not) {
            this.$Notice[not.type]({
                title: "COMPANY",
                desc: not.text
            });
        }
    },
    watch: {
        search: debounce(function(search) {
            this.fetchData({ search });
        }, 500)
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fetchData();
        });
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit("corporate/company/RESET_STATE");
        next();
    }
};
</script>
<style scoped>
.text-nowrap {
    white-space: nowrap;
}
</style>
